import { Injectable } from '@angular/core';
import 'rxjs/add/observable/empty';

function _window(): Window {
    return window;
}

@Injectable()
export class WindowRef {

    constructor() {
    }

    get nativeWindow(): Window {
        return _window();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/window.service.ts